import { Accordion, Col, Container, Row, Button,Dropdown } from "react-bootstrap"; 
import DetailItem from "../DataItem";
import { formatDate, formatTime } from "../../../../Utils/Common";
import { useNavigate } from "react-router-dom";
import navdots from '../../../../Assets/images/navdots.svg';
import { AdminService } from "../../../../Services/Admin.service";
import TokenService from "../../../../Services/Token.service";
import CancellationNoteModal from "../../../../Components/AdministrativeSettings/SampleRequest/CancellationNoteModal";
import { useState } from "react";
 
import { SampleRequestService } from "../../../../Services/SampleRequest.Service";
import Toaster from "../../../../Components/Toaster";
import Loader from "../../../../Components/Loader";
import InviteSpecialDonorModal from "../InviteSpecialDonorModal";
import ConfirmationModal from "../../../../Components/ConfirmationModal";
import HealthDataDownloadButton from "./HealthDataDownloadButton";
import HealthDataDownloadAllButton from "./HealthDataDownloadAllButton";
const RecruitedDonorAccordion= ({type, sampleRequestDetails,sampleTypeData, cancelAppointment, setLoading})=>{
    
    const navigate = useNavigate();    
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');
    const baseUrl = process.env.REACT_APP_BASE_URL || "";

    const viewDetails = (donor_id) => { 

        TokenService.updatePrevLink('/admin/donor-management');
         navigate(`/admin/donor-management/donor-profile`, { state: { id: donor_id  } });
    }
    const [showDeactivateModal, setShowDeactivateModal] = useState(false); 
    const handleShowDeactivateModal = () => setShowDeactivateModal(true);
    const handleCloseDeactivateModal = () => setShowDeactivateModal(false);

    const [appointmentId, setAppointmentId] = useState(null);
    const confirmCancelRequest = (cancellationNote) => {
        if(appointmentId){ 
            cancelAppointment({appt_id: appointmentId, cancel_reason : cancellationNote, canceled_by : TokenService.getUserId()});
        }
        handleCloseDeactivateModal();
    };
      

    const [showDeleteModal, setShowDeleteModal] = useState(false); 

    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => {
        // setIsNoShow(false);
        setShowDeleteModal(false);
    }  
  
    const confirmDeleteUser = () => {
        handleCloseDeleteModal();
        confirmSelectQualifiedDonor({request_id: sampleRequestDetails?.request?.id});        
    };

    const confirmSelectQualifiedDonor = async (payload) => {
        
        handleCloseSelectSpecificDonorModal();
        setLoading(true);
        try {
            const result = await SampleRequestService.inviteQualifiedDonor(payload);
            if (result.success == true) { 
                setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Qualified donors Invitedsucessfully:", result);
                setLoading(false);
            }
            else {
                // Check if the result.message is an object
                let formattedMessage = '';
                if (typeof result.message === 'object' && result.message !== null) {
                    // Convert object to a readable string
                    formattedMessage = Object.keys(result.message)
                        .map((key) => `${key}: ${result.message[key].join(', ')}`)
                        .join(' | ');
                } else {
                    // Use result.message directly if it's not an object
                    formattedMessage = result.message || 'An error occurred.';
                }

                setToastMessage(formattedMessage);
                // setToastMessage(result.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) { 
            console.error("Failed to invite qualified donors:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
  
    }; 
        const [showSelectSpecificDonorModal, setShowSelectSpecificDonorModal] = useState(false);
    
        const handleShowSelectSpecificDonorModal = () => setShowSelectSpecificDonorModal(true);
        const handleCloseSelectSpecificDonorModal = () => setShowSelectSpecificDonorModal(false);
    
        const confirmSelectSpecificDonor = async (payload) => {
            
            handleCloseSelectSpecificDonorModal();
            setLoading(true);
            try {
                const result = await SampleRequestService.inviteSpecificDonor(payload);
                if (result.success == true) { 
                    // setNavigateToAdmin(true);
                    console.log("Requestor Notified sucessfully:", result);
                    setLoading(false);
                    setToastMessage(result.message);
                    setShowToast(true);
                    setToastVariant('success');
                }
                else {
                    // Check if the result.message is an object
                    let formattedMessage = '';
                    if (typeof result.message === 'object' && result.message !== null) {
                        // Convert object to a readable string
                        formattedMessage = Object.keys(result.message)
                            .map((key) => `${key}: ${result.message[key].join(', ')}`)
                            .join(' | ');
                    } else {
                        // Use result.message directly if it's not an object
                        formattedMessage = result.message || 'An error occurred.';
                    }
    
                    setLoading(false);
                    setToastMessage(formattedMessage);
                    // setToastMessage(result.message);
                    setShowToast(true);
                    setToastVariant('error');
                }
            } catch (error) { 
                console.error("Failed to notify requestor:", error);
                setLoading(false);
                setToastMessage(error.message);
                setShowToast(true);
                setToastVariant('error');
            }
      
        }; 
    const inviteSpecificDonor = ()=>{
        handleShowSelectSpecificDonorModal();
    }

    const inviteQualifiedDonor = ()=>{
        handleShowDeleteModal();
    }
    // function downloadHealthData(requestId, donorId){
    //     SampleRequestService.downloadHealthData(requestId, donorId)
    //         .then((res) => {
    //         if (res.success) {debugger
    //             const downloadUrl = res.download_url;

    //             const link = document.createElement("a");
    //             link.href = downloadUrl;

    //             const filename =
    //                 downloadUrl.split("/").pop() ||
    //                 `healthdata_${requestId}_${donorId}.pdf`;
    //             link.setAttribute("download", filename);

    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);
    //             setShowToast(true);
    //             setToastMessage(res.message);
    //             setToastVariant("success");
    //         } else {
    //             setShowToast(true);
    //             setToastMessage(res.message || "Failed to download health data");
    //             setToastVariant("danger");
    //         }
    //     })
    //     .catch((error) => {
    //         setShowToast(true);
    //         setToastMessage("Error downloading health data.");
    //         setToastVariant("danger");
    //         console.error("Error downloading health data:", error);
    //     });
    // }
return(
    // <Accordion className="accordion-item" flush>
    <Accordion.Item eventKey="6">
         
        <Accordion.Header >
            <b>Recruited Donors   {sampleRequestDetails?.total_volunteers
                ?
                `(${sampleRequestDetails?.booked_count}/${sampleRequestDetails?.total_volunteers})`
                : 'Data unavailable'}</b>
            {/* {sampleRequestDetails?.request?.volunteers || '-'} */}
        </Accordion.Header>
        <Accordion.Body>
          {sampleRequestDetails?.booked_count > 0 && sampleRequestDetails?.request?.recruited_donors?.length > 0 ? (
            (() => {
                const donorIds = [
                    ...new Set(
                        sampleRequestDetails.request.recruited_donors.map(donor => donor.donor.id)
                    )
                ];
                return (
                <HealthDataDownloadAllButton
                    requestId={sampleRequestDetails.request.id}
                    donorId={donorIds}
                />
                );
            })()
            ) : null}


            {sampleRequestDetails?.booked_count > 0 && sampleRequestDetails?.request?.recruited_donors ? (<div className=" el-property-details-card-content">
                             {sampleRequestDetails?.request?.recruited_donors.map((recruitedDonor, index) => 
                <Row>
                    <Col md={12} className="mx-fit-content">
                        <div className="flex-sec justify-content-between col-xxl-6">
                            {/* Donor ID */}
                            <div className="d-flex jusity-content-between text-align-center">
                             <>
                             {type!=='requestor' ? (<>
                             
                               {/* <DetailItem 
                                    title="Donor ID"
                                    detail={ `${recruitedDonor.donor.donor_id}. Appointment Date : ${formatDate(recruitedDonor.appointment_date)} at ${formatTime(recruitedDonor.appointment_time)}` }
                                    />  */} 
                                                         <div className="el-flex-area mb-3">
                                                             <div className="el-content-detail">
                                                                 <p className="el-request-detail-profile-title">Donor ID :
                                                                     <span className="el-request-detail-profile-name">{<a
                                                                         href="#"
                                                                         onClick={(e) => {
                                                                             e.preventDefault();
                                                                             TokenService.updatePrevLink('/admin/donor-management');
                                                                             sessionStorage.setItem(
                                                                                 'donorprofile',
                                                                                 JSON.stringify({ id: recruitedDonor?.donor?.id })
                                                                             );

                                                                             const newTabUrl = `${baseUrl}/admin/donor-management/donor-profile`;
                                                                             window.open(newTabUrl, '_blank');
                                                                         }}
                                                                     >
                                                                         <span className="back-link">{recruitedDonor?.donor?.donor_id}.</span>
                                                                     </a>}{`Appointment Date : ${formatDate(recruitedDonor.appointment_date)} at ${formatTime(recruitedDonor.appointment_time)}`}</span></p>
                                                             </div>
                                                             {/* <HealthDataDownloadButton requestId={sampleRequestDetails.request.id} donorId={recruitedDonor.donor.id}></HealthDataDownloadButton> */}
                                                         </div>
                                    </>):
                                    (  
                                        <> 
                                        <div className="el-flex-area mb-3">
                                             <DetailItem
                                                title="Donor ID"
                                                detail={`${recruitedDonor.donor.donor_id}. ${recruitedDonor.donor.gender =='XY' ? "Male" : "Female"} (${recruitedDonor.donor.gender})`}
                                            />   
                                           {/* <button
                                            type="button"
                                            className="el-main-button"
                                            onClick={()=>downloadHealthData( sampleRequestDetails.request.id, recruitedDonor.donor.id)}>
                                            <span>Download Health Data</span>
                                            </button> */}
                                            <HealthDataDownloadButton requestId={sampleRequestDetails.request.id} donorId={recruitedDonor.donor.id}></HealthDataDownloadButton>
                                        </div>
                                        </>  
                                   ) }
                             </> 
                          
                           {type!='requestor' && (
                            <>
                            {/* Dropdown Menu */}
                            <div className="dropdown mb-3 mb-lg-0">
                                <Dropdown>
                                    <Dropdown.Toggle variant="secondary"    id="dropdown-basic">
                                        <img src={navdots} alt="" />
                                    </Dropdown.Toggle>
                                    {/* //if SR is cancelled then cannot cancel appointment */}
                                    {sampleRequestDetails.request.status  !== 4  && (
                                        <>
                                            <Dropdown.Menu className="el-admin">
                                                <Dropdown.Item onClick={() => viewDetails(recruitedDonor.donor.id)}>View Details</Dropdown.Item>
                                                {/* <Dropdown.Item ><HealthDataDownloadButton requestId={sampleRequestDetails.request.id} donorId={recruitedDonor.donor.id} type={'label'}></HealthDataDownloadButton></Dropdown.Item> */}

                                              
                                                {(() => { 
                                                    const acceptedSamples = recruitedDonor?.accepted_samples?.split(",").map(s => s.trim()).sort();
                                                    const donatedSamples = recruitedDonor?.donated_samples?.split(",").map(s => s.trim()).sort();

                                                    // Compare  
                                                    if (JSON.stringify(acceptedSamples) !== JSON.stringify(donatedSamples)) {
                                                        return (
                                                            <Dropdown.Item className="text-danger" onClick={() => {
                                                                setAppointmentId(recruitedDonor.appointment_id);
                                                                handleShowDeactivateModal();
                                                            }}>
                                                                <span >Cancel Appointment</span>
                                                            </Dropdown.Item>
                                                        );
                                                    }
                                                    return null;
                                                })()}
                                            </Dropdown.Menu> 
                                        </>
                                    )}
                                </Dropdown>
                            </div>
                            </>
                           )}
                            </div> 
                        </div>
                    </Col>
                </Row>
                             )}
            </div>) : (<span className=" text-danger">Job not yet accepted by donor(s).</span>)}
            {/* Buttons */}
            {sampleRequestDetails?.booked_count != sampleRequestDetails?.total_volunteers &&  type!=='requestor' &&( 
                <div className="d-flex mt-3 w-f-content justify-content-center">
                    <button  disabled={sampleRequestDetails?.request?.status === 4 }   onClick={()=>inviteQualifiedDonor()} variant="primary" className="el-main-button me-3 btn" data-bs-toggle="modal" data-bs-target="#Invite_qulified_donor">
                        <span>
                        Invite Qualified Donor</span>
                    </button>
                    <button  disabled={sampleRequestDetails?.request?.status === 4 }   onClick={()=>inviteSpecificDonor()} variant="outline-primary" className="el-main-button me-3 btn" data-bs-toggle="modal" data-bs-target="#Invite_Specific_donor">
                        <span>Invite A Specific Donor</span>
                    </button>
                </div>
            )}
        </Accordion.Body>
        <CancellationNoteModal 
                show={showDeactivateModal}
                onHide={handleCloseDeactivateModal}
                onConfirm={confirmCancelRequest}
                title="Cancel Donor Appointment"
                type={"appointment"}
            />
            
            <InviteSpecialDonorModal
                show={showSelectSpecificDonorModal}
                onHide={handleCloseSelectSpecificDonorModal}
                onConfirm={confirmSelectSpecificDonor} 
                id={sampleRequestDetails?.request?.id}
                ismatched ={sampleRequestDetails?.request?.matched_sample}
            />

            <ConfirmationModal
                    show={showDeleteModal}
                    onHide={handleCloseDeleteModal}
                    onConfirm={confirmDeleteUser}
                
                    body="Are you sure you want to do this?"
                    type="donor-no-show"
                />
              <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
    </Accordion.Item>
// </Accordion>

);
}

export default RecruitedDonorAccordion